import {css} from "@panda/css";

export const HomeMatchBasicPreferencesFlowResignationDescription = () => (
    <>
        Bez tej opcji <span className={boldTextStyle}>przestaniemy automatycznie wysyłać zapytania w Twoim imieniu.</span> Oznacza to, że najlepsze okazje mogą
        Cię ominąć, a Ty wrócisz do samodzielnego przeglądania setek ogłoszeń. Na pewno chcesz szukać mieszkań na własną rękę?
    </>
);

const boldTextStyle = css({
    fontWeight: 700
});
import {css} from "@panda/css";

export const HomeMatchBasicPreferencesFlowResignationDescription = () => (
    <>
        Bez tej opcji <span className={boldTextStyle}>przestaniemy automatycznie wysyłać zapytania w Twoim imieniu.</span> Oznacza to, że najlepsze okazje mogą
        Cię ominąć, a Ty wrócisz do samodzielnego przeglądania setek ogłoszeń. Na pewno chcesz szukać mieszkań na własną rękę?
    </>
);

const boldTextStyle = css({
    fontWeight: 700
});
